var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2881_44705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 18.2441L10.4893 25.755C9.89591 26.3484 9.5625 27.1368 9.5625 27.7364L10.5989 28.4267H20.4395L18.0001 18.2441Z",
    fill: "#E1F5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4376 32.4826V27.9924C26.4376 27.1532 26.1042 26.3484 25.5108 25.755L18 18.2441V32.4826H26.4376Z",
    fill: "#CCEFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.162 5.45801L9.5625 6.11467V8.49551C9.5625 9.33468 9.89584 10.1395 10.4893 10.7329L12.1993 12.4429L21.2994 13.5579L23.6434 5.45801H10.162Z",
    fill: "#E1F5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 4.00586V6.11524H19.5821C20.7471 6.11524 21.6915 7.05964 21.6915 8.22462V8.49608C21.6915 9.33525 21.5248 10.1401 21.2281 10.7334L20.2844 12.621L23.8009 12.4435L25.5109 10.7335C26.1043 10.1401 26.4377 9.33531 26.4377 8.49608V4.00586H9.5625Z",
    fill: "#CCEFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 12.4434L17.0093 17.2535C17.306 17.5502 17.4727 17.9526 17.4727 18.3722L20.911 13.0037L20.3731 12.4434H12.1992V12.4434Z",
    fill: "#D1CEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 24.9717C17.4727 25.3912 17.3061 25.7937 17.0094 26.0904L15.8267 27.273C15.53 27.5697 15.1276 27.7364 14.708 27.7364H9.5625V32.4825H19.6351V28.1493L17.4727 24.9717Z",
    fill: "#D1CEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4376 27.7365H21.292C20.8725 27.7365 20.4701 27.5698 20.1735 27.2731L18.9908 26.0904C18.6941 25.7937 18.5273 25.3913 18.5273 24.9717V18.3721C18.5273 17.9526 18.694 17.5501 18.9907 17.2534L23.8008 12.4434H20.3731L17.8929 16.7619C17.6176 17.2414 17.4727 17.7848 17.4727 18.3377V25.034C17.4727 25.7708 17.6442 26.4975 17.9737 27.1565L18.5536 28.3164C18.8831 28.9754 19.0546 29.7021 19.0546 30.4389V32.4826H26.4375V27.7365H26.4376Z",
    fill: "#D1CEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8009 1.89648H9.5625C8.97998 1.89648 8.50781 2.36872 8.50781 2.95117V4.00586L9.5625 4.5576H24.8556V2.95117C24.8556 2.36872 24.3834 1.89648 23.8009 1.89648Z",
    fill: "#766CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4377 1.89648H23.8009V2.95117C23.8009 3.53363 23.3287 4.00586 22.7463 4.00586H8.50781C8.50781 4.58832 8.98005 5.06055 9.5625 5.06055H26.4377C27.0201 5.06055 27.4924 4.58832 27.4924 4.00586V2.95117C27.4924 2.36866 27.0202 1.89648 26.4377 1.89648Z",
    fill: "#675CF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8009 31.4277H9.5625C8.97998 31.4277 8.50781 31.9 8.50781 32.4824V33.5371L9.5625 34.0889H24.8556V32.4824C24.8556 31.8999 24.3834 31.4277 23.8009 31.4277Z",
    fill: "#766CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4377 31.4277H23.8009V32.4824C23.8009 33.0649 23.3287 33.5371 22.7463 33.5371H8.50781C8.50781 34.1196 8.98005 34.5918 9.5625 34.5918H26.4377C27.0201 34.5918 27.4924 34.1196 27.4924 33.5371V32.4824C27.4924 31.8999 27.0202 31.4277 26.4377 31.4277Z",
    fill: "#675CF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2881_44705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.6956,
    height: 32.6956,
    fill: "white",
    transform: "translate(1.65234 1.89648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClockIcon);
export default __webpack_public_path__ + "static/media/sand-clock-icon.019f8a9468dc05082c0eb202e53a12f2.svg";
export { ForwardRef as ReactComponent };